// extracted by mini-css-extract-plugin
module.exports = {"icon":"_25a5JPagg0uHkHLZkYAn0C"};